import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { GlobalVariables } from 'app/services/globals';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';
import { GoogleBigQueryObjectV2Dataset } from 'app/model/dataset/google-bigquery-v2.dataset';
import { ValueAdapter } from '../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleBigQueryObjectV2Dataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            version: GlobalVariables.enableGBQVersion && __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                dataset: '*',
                table: '*'
            }
        }
    }
})
export class GoogleBigQueryObjectV2DatasetAdapter extends TabularTypeDatasetAdapter<GoogleBigQueryObjectV2Dataset, Model.DatasetResource> {
    protected async _toResource(dataset: GoogleBigQueryObjectV2Dataset): Promise<Model.DatasetResource> {
        const datasetResource = await this._toResourceInternal(dataset, Metamodel.modelFor(GoogleBigQueryObjectV2Dataset).name, undefined, 'dataset');
        if (GlobalVariables.enableGBQVersion && __IS_FABRIC_DPE__) {
            datasetResource.properties.version = ValueAdapter.toResource(dataset, GoogleBigQueryObjectV2Dataset.VERSION);
        }
        return datasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: GoogleBigQueryObjectV2Dataset): Promise<GoogleBigQueryObjectV2Dataset> {
        const modelDataset = await this._toModelInternal(modelDatasetResource, dataset, GoogleBigQueryObjectV2Dataset.MODEL, undefined, 'dataset');
        if (GlobalVariables.enableGBQVersion && __IS_FABRIC_DPE__) {
            dataset.version = undefined;
            ValueAdapter.toModel(dataset, GoogleBigQueryObjectV2Dataset.VERSION, modelDatasetResource.properties.version);
        }
        return modelDataset;
    }
}
